import React, { Suspense } from 'react'
import { Await, Outlet, useLoaderData } from 'react-router-dom'
import { AuthProvider } from '../hooks/auth'
import { User } from '../services/auth'
import CookieConsent from '../components/CookieConsent'
import LoadingIcon from '../components/LoadingIcon'

const RootLayout: React.FC = () => {
    const { userPromise } = useLoaderData() as {
        userPromise: Promise<User | null>
    }

    return (
        <Suspense
            fallback={
                <div className="flex flex-col items-center justify-center h-full gap-5">
                    <div className="text-[#181818] dark:text-[#FFFFFF] text-xs w-[500px] text-center ">
                        NOXSYS – современная система автоматизации закупок для
                        организаций-заказчиков, работающих по Федеральному
                        закону “О закупках товаров, работ, услуг отдельными
                        видами юридических лиц" от 18.07.2011 N 223-ФЗ
                    </div>
                    <p className="text-[#181818] dark:text-[#FFFFFF] text-xs">
                        <div className="flex w-full h-full items-center justify-center">
                            <LoadingIcon />
                        </div>
                    </p>
                </div>
            }
        >
            <Await resolve={userPromise}>
                {(user) => (
                    <AuthProvider user={user}>
                        <Outlet />
                    </AuthProvider>
                )}
            </Await>
            <CookieConsent />
        </Suspense>
    )
}

export default RootLayout
